import React from 'react';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';


export default function InviteRedirect() {
  const { code } = useParams();

  
  useEffect(() => {
    // 1) Intent URL para Android Chrome (intenta app link verificado)
    const host = window.location.host;

    const fallback = 'https://play.google.com/store/apps/details?id=com.layoons.prototipoinventario2024';



    const intentUri =
      `intent://${host}/unirse/${code}` + 
      `#Intent;` +
      `scheme=https;` +
      `package=com.layoons.prototipoinventario2024;` +
      `S.browser_fallback_url=${encodeURIComponent(fallback)};` +
      `end`;
   
    
    // Primero intenta lanzar el intent (Android)
    window.location.replace(intentUri);
  }, [code]);

  return (
    <div style={{ textAlign: 'center', padding: '2rem' }}>
      <h1>Abriendo Mercanteo México…</h1>
      <p>
        Si no se abre automáticamente,{' '}
        <a 
          href="https://play.google.com/store/apps/details?id=com.layoons.prototipoinventario2024" 
          target="_blank" rel="noreferrer"
        >
          descárgala aquí
        </a>.
      </p>
    </div>
  );
}